<section class="mock-section overflow-hidden" id="mock-interviews">
  <div class="mock-container">
    <!-- Header -->
    <div class="flex items-center justify-between gap-4">
      <h2 class="mock-section-title">
        <span class="hidden md:inline">AI Mock <span class="brand-gradient-text">Interviews</span></span>
        <span class="md:hidden brand-gradient-text">Mock Interviews</span>
      </h2>
      <button class="btn-view-all group" (click)="onViewAll()" data-testid="mock-view-all">
        <span class="hidden sm:inline">View all</span><span class="sm:hidden">All</span>
        <svg aria-hidden="true" class="lucide lucide-arrow-right w-4 h-4" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 12h14"></path>
          <path d="m12 5 7 7-7 7"></path>
        </svg>
      </button>
    </div>
    <p class="mock-subtitles mt-2 text-slate-600">
      Practice realistic AI-powered video interviews and receive instant, personalized feedback
    </p>

    <!-- Carousel Container -->
    <div class="relative group mt-8">
      <!-- Left Arrow -->
      <button (click)="scrollLeft()" *ngIf="!isAtStart" class="arrow-btn hidden lg:flex absolute -left-12 top-1/2 -translate-y-1/2 z-10">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7"></path></svg>
      </button>

      <!-- Scrollable Grid -->
      <div class="mock-grid" #mockGrid (scroll)="onGridScroll()">
        <!-- Loading State -->
        <ng-container *ngIf="loading">
          <div class="mock-card w-[95vw] sm:w-[50vw] md:w-full min-w-full flex justify-center items-center py-20 border-none shadow-none bg-transparent">
            <div class="animate-spin rounded-full h-10 w-10 border-b-2 border-green-500"></div>
          </div>
        </ng-container>

        <!-- Empty State -->
        <ng-container *ngIf="!loading && interviews.length === 0">
          <div class="mock-card w-[95vw] sm:w-[50vw] md:w-full min-w-full flex justify-center items-center py-20 border-none shadow-none bg-transparent">
            <div class="card h-100 p-4 w-full max-w-md mx-auto text-center" style="border-radius: 12px; border: 1px solid #e0e0e0; background: white;">
              <i class="bi bi-clock-history mb-3" style="font-size: 2rem; color: #a0a0a0;"></i>
              <h5 class="mb-2" style="font-size: 1.1rem; font-weight: 600;">More interviews coming soon</h5>
              <p class="text-muted" style="font-size: 0.9rem;">We are actively building more practice mock interviews.</p>
            </div>
          </div>
        </ng-container>

        
        <!-- Interview Cards -->
        <ng-container *ngIf="!loading && interviews.length > 0">
          <div *ngFor="let interview of interviews; let i = index" [attr.data-testid]="'interview-card-' + i" class="mock-card">
            <div class="mock-card-header">
              <div class="mock-company-info">
                <div class="mock-logo-wrapper">
                  <div class="mock-logo">
                    <ng-container *ngIf="interview.practice_company_logo; else showCompanyName">
                    <img [alt]="interview.practice_company_name" loading="lazy" [src]="interview.practice_company_logo" 
                    onerror="this.onerror=null; this.src='assets/images/default-company.png'">
                    </ng-container>
                    <ng-template #showCompanyName>
                        <div class="company-initial"> {{ interview.practice_company_name?.charAt(0)?.toUpperCase() || '?' }}</div>
                    </ng-template>
                  </div>
                  <span class="mock-logo-glow"></span>
                  <span class="mock-logo-badge">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <polygon points="23 7 16 12 23 17 23 7"></polygon>
                      <rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect>
                    </svg>
                  </span>
                </div>
                <div>
                  <h3 class="mock-title" [title]="interview.practice_company_name">{{ interview.job_role }}</h3>
                  <p class="mock-subtitle" [title]="interview.job_role">{{ interview.practice_company_name }}</p>
                </div>
              </div>
              <span class="mock-badge mock-badge-emerald">Mock</span>
            </div>

            <div class="mock-details">
              <span class="mock-detail-item">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polygon points="23 7 16 12 23 17 23 7"></polygon>
                  <rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect>
                </svg>
                AI Interview
              </span>
              <span class="mock-detail-item">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <polyline points="12 6 12 12 16 14"></polyline>
                </svg>
                {{ interview.total_duration_minutes }} mins
              </span>
            </div>

            <div class="mock-footer">
              <span class="mock-stats">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
                  <path d="M18 17V9"></path>
                  <path d="M13 17V5"></path>
                  <path d="M8 17v-3"></path>
                </svg>
                100+ completed
              </span>
              <button [attr.data-testid]="'interview-start-' + i" class="btn-primary-small" (click)="onStartInterview(interview.id)">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="fill-white">
                  <polygon points="6 3 20 12 6 21 6 3"></polygon>
                </svg>
                Start Now
              </button>
            </div>
          </div>
        </ng-container>
      </div>

      <!-- Right Arrow -->
      <button (click)="scrollRight()" *ngIf="!isAtEnd" class="arrow-btn hidden lg:flex absolute -right-12 top-1/2 -translate-y-1/2 z-10">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7"></path></svg>
      </button>
    </div>
  </div>
</section>
